"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Headers = void 0;
const head_1 = __importDefault(require("next/head"));
const react_1 = __importDefault(require("react"));
const Headers = ({ alternativeUrls, canonical }) => {
    const alternativeUrlLanguages = Object.keys(alternativeUrls);
    return (react_1.default.createElement(head_1.default, null,
        canonical && react_1.default.createElement("link", { key: "canonical", rel: "canonical", href: canonical }),
        alternativeUrlLanguages.length > 1
            ? alternativeUrlLanguages.map(lang => (react_1.default.createElement("link", { key: `alternate-${lang}`, rel: "alternate", href: alternativeUrls[lang], hrefLang: lang })))
            : null));
};
exports.Headers = Headers;
//# sourceMappingURL=headers.js.map